/* TCD product page — gallery, variant switching, content tabs, sticky panels, cross-sell loaders.
   Progressive enhancement over the server-rendered page (native selects, <details>, GET forms). */
(function () {
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const cfg = window.tcd || {};
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  function headerOffset() {
    const h = $('.tcd-section-header.is-sticky');
    const off = h ? h.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--tcd-header-offset', off + 'px');
    return off;
  }

  /* ---------- gallery ---------- */
  function initGallery(g) {
    const track = $('[data-tcd-gallery-track]', g);
    if (!track) return;
    const slides = $$('[data-tcd-slide]', track);
    const total = slides.length;
    const dots = $$('.tcd-gallery__dot', g);
    const thumbs = $$('[data-tcd-thumb]', g);
    const counter = $('[data-tcd-gallery-current]', g);
    let current = 0;
    function goTo(i, smooth) {
      i = Math.max(0, Math.min(total - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false || reduced ? 'auto' : 'smooth' });
    }
    function setActive(i) {
      if (i === current) return;
      current = i;
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      thumbs.forEach((t) => { const on = Number(t.dataset.tcdThumb) === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); if (on && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); });
      if (counter) counter.textContent = String(i + 1);
      // stop playback when the slide leaves view
      slides.forEach((s, k) => { if (k !== i) { const fr = s.querySelector('iframe, video'); if (fr) restoreFacade(s); } });
    }
    let raf = null;
    track.addEventListener('scroll', () => { if (raf) return; raf = requestAnimationFrame(() => { raf = null; const i = Math.round(track.scrollLeft / track.clientWidth); setActive(i); }); });
    const prev = $('[data-tcd-gallery-prev]', g), next = $('[data-tcd-gallery-next]', g);
    if (prev) prev.addEventListener('click', () => goTo(current - 1));
    if (next) next.addEventListener('click', () => goTo(current + 1));
    thumbs.forEach(t => t.addEventListener('click', () => goTo(Number(t.dataset.tcdThumb))));
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); } });
    // video facades
    function restoreFacade(slide) {
      const html = slide.dataset.tcdFacadeHtml; if (!html) return;
      slide.innerHTML = html; delete slide.dataset.tcdFacadeHtml;
    }
    g.addEventListener('click', (e) => {
      const f = e.target.closest('[data-tcd-video]');
      if (!f) return;
      const slide = f.closest('[data-tcd-slide]') || f.parentElement;
      slide.dataset.tcdFacadeHtml = slide.innerHTML;
      const kind = f.dataset.tcdVideo;
      if (kind === 'native') { slide.innerHTML = '<video controls autoplay playsinline src="' + f.dataset.tcdVideoSrc + '"></video>'; }
      else if (kind === 'vimeo') { slide.innerHTML = '<iframe src="https://player.vimeo.com/video/' + f.dataset.tcdVideoId + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen title="Video"></iframe>'; }
      else { slide.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + f.dataset.tcdVideoId + '?autoplay=1&rel=0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="Video"></iframe>'; }
    });
    // fullscreen dialog
    const dialog = $('[data-tcd-gallery-dialog]', g);
    if (dialog && dialog.showModal) {
      const stage = $('[data-tcd-dialog-stage]', dialog), dthumbs = $$('[data-tcd-dialog-thumb]', dialog), dcount = $('[data-tcd-dialog-counter]', dialog);
      function showBig(k) {
        const t = dthumbs[k]; if (!t) return;
        stage.innerHTML = '<img src="' + t.dataset.tcdDialogThumb + '" alt="">';
        dthumbs.forEach((b, i) => b.classList.toggle('is-active', i === k));
        if (dcount) dcount.textContent = (k + 1) + ' / ' + dthumbs.length;
      }
      $('[data-tcd-gallery-open]', g).addEventListener('click', () => { dialog.showModal(); const imgIdx = Math.min(current, dthumbs.length - 1); showBig(Math.max(0, imgIdx)); });
      $$('[data-tcd-dialog-close]', dialog).forEach(b => b.addEventListener('click', () => dialog.close()));
      dthumbs.forEach((b, k) => b.addEventListener('click', () => showBig(k)));
      dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
      let touchY = null;
      dialog.addEventListener('touchstart', (e) => { touchY = e.touches[0].clientY; }, { passive: true });
      dialog.addEventListener('touchend', (e) => { if (touchY !== null && e.changedTouches[0].clientY - touchY > 80) dialog.close(); touchY = null; }, { passive: true });
    }
    g.tcdGoTo = goTo;
    g.tcdGoToMedia = (mediaId) => { const i = slides.findIndex(s => s.dataset.mediaId === String(mediaId)); if (i >= 0) goTo(i); };
  }

  /* ---------- variants ---------- */
  function initVariants(root) {
    const picker = $('[data-tcd-variants]', root);
    const jsonEl = $('[data-tcd-product-json]', root);
    if (!jsonEl) return;
    let product; try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    const sectionId = root.dataset.sectionId;
    const form = $('[data-tcd-product-form]', root);
    if (!picker) return;
    const selects = $$('[data-tcd-option-select]', picker);
    // upgrade selects to pills
    $$('[data-tcd-option-pills]', picker).forEach(p => {
      p.hidden = false;
      const idx = Number(p.dataset.tcdOptionPills);
      const sel = selects[idx];
      p.addEventListener('click', (e) => {
        const b = e.target.closest('[data-tcd-pill]'); if (!b) return;
        sel.value = b.dataset.tcdPill; sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    function selectedOptions() { return selects.map(s => s.value); }
    function findVariant(opts) { return product.variants.find(v => v.options.every((o, i) => o === opts[i])); }
    function paintAvailability() {
      const opts = selectedOptions();
      $$('[data-tcd-option-pills]', picker).forEach(p => {
        const idx = Number(p.dataset.tcdOptionPills);
        $$('[data-tcd-pill]', p).forEach(b => {
          const test = opts.slice(); test[idx] = b.dataset.tcdPill;
          const v = findVariant(test);
          b.classList.toggle('is-unavailable', !v || !v.available);
          const on = opts[idx] === b.dataset.tcdPill;
          b.classList.toggle('is-selected', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        const val = $('[data-tcd-option-value]', p.closest('.tcd-variants__group')); if (val) val.textContent = opts[idx];
      });
    }
    // the compact panel lives in the content section — re-render it from its own Liquid so price,
    // stock and availability all follow the variant (it disappears for an unavailable one)
    async function refreshCompact(variantId) {
      const slot = $('[data-tcd-compact-slot]'); if (!slot) return;
      try {
        const r = await fetch(root.dataset.productUrl + '?variant=' + variantId + '&section_id=' + slot.dataset.sectionId, { headers: { Accept: 'text/html' } });
        const fresh = new DOMParser().parseFromString(await r.text(), 'text/html').querySelector('[data-tcd-compact-slot]');
        if (fresh && root.dataset.variantId === String(variantId)) slot.innerHTML = fresh.innerHTML;
      } catch (e) { /* keep current */ }
    }
    async function onChange() {
      paintAvailability();
      const v = findVariant(selectedOptions());
      if (!v) return;
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      root.dataset.variantId = v.id;
      const idInput = $('[data-tcd-variant-input]', root); if (idInput) idInput.value = v.id;
      if (v.featured_media && v.featured_media.id) { const g = $('[data-tcd-gallery]', root); if (g && g.tcdGoToMedia) g.tcdGoToMedia(v.featured_media.id); }
      // re-render price / stock / dispatch / cta / identifiers from Liquid for this variant
      root.setAttribute('aria-busy', 'true');
      try {
        const r = await fetch(root.dataset.productUrl + '?variant=' + v.id + '&section_id=' + sectionId, { headers: { Accept: 'text/html' } });
        const html = await r.text();
        if (root.dataset.variantId !== String(v.id)) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-tcd-price]', '[data-tcd-stock]', '[data-tcd-dispatch]', '[data-tcd-identifiers]', '[data-tcd-finance]'].forEach(sel => {
          const fresh = doc.querySelector(sel), cur = $(sel, root);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML; else if (cur && !fresh) cur.innerHTML = '';
        });
        const freshCta = doc.querySelector('[data-tcd-cta]'), curCta = $('[data-tcd-cta]', root);
        if (freshCta && curCta) { const qty = curCta.querySelector('[name=quantity]'); const keep = qty ? qty.value : null; curCta.innerHTML = freshCta.innerHTML; const nq = curCta.querySelector('[name=quantity]'); if (nq && keep) { const mx = Number(nq.max || 0); nq.value = mx && Number(keep) > mx ? mx : keep; } }
        const freshSticky = doc.querySelector('.tcd-stickybar'), currentSticky = document.querySelector('.tcd-stickybar');
        if (freshSticky && currentSticky) currentSticky.innerHTML = freshSticky.innerHTML;
        else if (currentSticky) currentSticky.hidden = true;
        refreshCompact(v.id);
        const sp = $('[data-tcd-sticky-price]'); if (sp && cfg.money) sp.innerHTML = cfg.money(Math.round(v.price * (v.taxable ? (cfg.vat || 1.2) : 1))) + ' <small>inc VAT</small>';
        document.dispatchEvent(new CustomEvent('tcd:variant:change', { detail: { variant: v } }));
        if (window.tcdInitCountdown) window.tcdInitCountdown();
      } catch (e) { /* keep current */ }
      finally { root.removeAttribute('aria-busy'); }
    }
    selects.forEach(s => s.addEventListener('change', onChange));
    paintAvailability();
    // size guide dialog
    const sg = $('[data-tcd-size-guide]', picker), sgd = $('[data-tcd-size-guide-dialog]', picker);
    if (sg && sgd && sgd.showModal) { sg.addEventListener('click', () => sgd.showModal()); $$('[data-tcd-dialog-close]', sgd).forEach(b => b.addEventListener('click', () => sgd.close())); sgd.addEventListener('click', (e) => { if (e.target === sgd) sgd.close(); }); }
  }

  /* ---------- content tabs ---------- */
  function initContent(c) {
    const panels = $$('[data-tcd-panel]', c);
    const tabs = $('[data-tcd-tabs]', c);
    if (!panels.length || !tabs) return;
    // jump list for no-JS is CSS-hidden; tabs built here
    tabs.innerHTML = panels.map(p => '<button class="tcd-content__tab" type="button" role="tab" id="' + p.id + '-tab" aria-controls="' + p.id + '" aria-selected="false" data-tcd-tab-for="' + p.id + '">' + p.dataset.tcdLabel + (p.dataset.tcdCount ? '<span class="tcd-count">' + p.dataset.tcdCount + '</span>' : '') + '</button>').join('');
    const btns = $$('[data-tcd-tab-for]', tabs);
    function activate(id, scroll) {
      if (!isDesktop()) { const p = document.getElementById(id); if (p) { p.open = true; if (scroll) p.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); } return; }
      panels.forEach(p => { const on = p.id === id; p.classList.toggle('is-active', on); if (on) p.open = true; });
      btns.forEach(b => b.setAttribute('aria-selected', b.dataset.tcdTabFor === id ? 'true' : 'false'));
      if (scroll) { const top = c.getBoundingClientRect().top + window.scrollY - headerOffset() - 8; window.scrollTo({ top, behavior: reduced ? 'auto' : 'smooth' }); }
    }
    btns.forEach(b => b.addEventListener('click', () => { activate(b.dataset.tcdTabFor, true); history.replaceState({}, '', '#' + b.dataset.tcdTabFor); }));
    const hash = location.hash.replace('#', '');
    activate(panels.some(p => p.id === hash) ? hash : panels[0].id, false);
    if (panels.some(p => p.id === hash)) setTimeout(() => activate(hash, true), 200);
    // rating link → reviews tab
    document.addEventListener('click', (e) => { const a = e.target.closest('a[href="#tcd-tab-reviews"]'); if (a && document.getElementById('tcd-tab-reviews')) { e.preventDefault(); activate('tcd-tab-reviews', true); } });
    window.addEventListener('resize', () => { if (isDesktop() && !panels.some(p => p.classList.contains('is-active'))) activate(panels[0].id, false); });
    // reviews: Judge.me renders when its widget is in view; nothing to do
    // inline video facades inside panels
    c.addEventListener('click', (e) => {
      const f = e.target.closest('.tcd-facade[data-tcd-video]'); if (!f) return;
      const wrap = document.createElement('div'); wrap.className = 'tcd-facade';
      wrap.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + f.dataset.tcdVideoId + '?autoplay=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen title="Video"></iframe>';
      f.replaceWith(wrap);
    });
  }

  /* ---------- sticky mobile bar ---------- */
  function initStickyBar(root) {
    const bar = $('[data-tcd-stickybar]');
    const cta = $('[data-tcd-cta]', root);
    if (!bar || !cta) return;
    let ticking = false;
    function paint() {
      ticking = false;
      // position-driven: an IntersectionObserver alone misses jump scrolls and
      // restored positions, where the CTA never crosses the viewport.
      const show = !isDesktop() && cta.getBoundingClientRect().bottom < 0;
      if (bar.hidden === !show) return;
      bar.hidden = !show;
      document.body.classList.toggle('tcd-stickybar-visible', show);
    }
    function onScroll() { if (ticking) return; ticking = true; window.requestAnimationFrame(paint); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.addEventListener('tcd:variant:change', onScroll);
    paint();
    document.addEventListener('click', (e) => { const a = e.target.closest('[data-tcd-scroll-buybox]'); if (!a) return; e.preventDefault(); const bb = $('[data-tcd-buybox]'); if (bb) bb.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' }); });
    // compact panel qty → main form
    document.addEventListener('change', (e) => { const q = e.target.closest('[data-tcd-compact-qty]'); if (!q) return; const main = $('[data-tcd-product-form] [name=quantity]'); if (main) main.value = q.value; });
  }

  /* ---------- cross-sell loaders ---------- */
  function initRecs() {
    $$('[data-tcd-recs]').forEach(async (el) => {
      const url = (el.dataset.url || '/recommendations/products') + '?section_id=' + el.dataset.sectionId + '&product_id=' + el.dataset.productId + '&intent=' + el.dataset.intent + '&limit=' + el.dataset.limit;
      try {
        const r = await fetch(url); const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('.tcd-recs');
        if (inner) { el.replaceWith(inner); initFbt(inner); } else { el.closest('.shopify-section') && (el.closest('.shopify-section').hidden = true); }
      } catch (e) { /* leave empty */ }
    });
  }
  function initFbt(scope) {
    const fbt = $('[data-tcd-fbt]', scope); if (!fbt) return;
    const boxes = $$('[data-tcd-fbt-item]', fbt), inc = $('[data-tcd-fbt-inc]', fbt), ex = $('[data-tcd-fbt-ex]', fbt), cnt = $('[data-tcd-fbt-count]', fbt), btn = $('[data-tcd-fbt-add]', fbt);
    function total() {
      let e = 0, i = 0, n = 0;
      boxes.forEach(b => {
        const thumb = $('[data-tcd-fbt-thumb="' + b.value + '"]', scope);
        if (thumb) thumb.classList.toggle('is-off', !b.checked || b.disabled);
        if (!b.checked || b.disabled) return;
        const p = Number(b.dataset.price); e += p; i += b.dataset.taxable === 'false' ? p : Math.round(p * (cfg.vat || 1.2)); n++;
      });
      if (inc && cfg.money) inc.textContent = cfg.money(i);
      if (ex && cfg.money) ex.textContent = cfg.money(e) + ' ex VAT';
      if (cnt) cnt.textContent = 'Total for ' + n + ' item' + (n === 1 ? '' : 's');
      if (btn) { btn.textContent = n === 1 ? 'Add to cart' : 'Add all ' + n + ' to cart'; btn.disabled = n === 0; }
    }
    boxes.forEach(b => b.addEventListener('change', total)); total();
    if (btn) btn.addEventListener('click', async () => {
      const items = boxes.filter(b => b.checked && !b.disabled).map(b => ({ id: Number(b.value), quantity: 1 }));
      if (!items.length || !cfg.cart) return;
      btn.setAttribute('aria-busy', 'true');
      try { await cfg.cart.add(items); } catch (e) { alert(e.message); } finally { btn.removeAttribute('aria-busy'); }
    });
  }

  /* ---------- recently viewed section ---------- */
  async function initRecent() {
    const sec = $('[data-tcd-recent-section]'); if (!sec) return;
    let handles = []; try { handles = JSON.parse(localStorage.getItem('tcd_recent') || '[]'); } catch (e) { return; }
    handles = handles.filter(h => h !== sec.dataset.exclude).slice(0, Number(sec.dataset.count) || 4);
    if (!handles.length) return;
    const grid = $('[data-tcd-recent-grid]', sec); let html = '';
    for (const h of handles) {
      try {
        const p = await (await fetch('/products/' + h + '.js')).json(); const v = p.variants[0];
        const img = p.featured_image ? '<img src="' + p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x400$1$2') + '" width="400" height="400" alt="" loading="lazy">' : '';
        const inc = cfg.money ? cfg.money(Math.round(v.price * (v.taxable ? (cfg.vat || 1.2) : 1))) : '';
        html += '<li><article class="tcd-card"><a class="tcd-card__media" href="' + p.url + '" tabindex="-1" aria-hidden="true">' + img + '</a><div class="tcd-card__body"><span class="tcd-card__vendor">' + (p.vendor || '') + '</span><h3 class="tcd-card__title"><a href="' + p.url + '">' + p.title.replace(/</g, '&lt;') + '</a></h3><div class="tcd-card__price"><div class="tcd-price tcd-price--card"><div class="tcd-price__lead"><span class="tcd-price__inc">' + inc + '</span><span class="tcd-price__label">inc VAT</span></div><div class="tcd-price__ex"><span>' + (cfg.money ? cfg.money(v.price) : '') + '</span><span class="tcd-price__label">ex VAT</span></div></div></div><div class="tcd-card__actions">' + (p.variants.length === 1 && v.available ? '<form action="/cart/add" method="post" data-tcd-add><input type="hidden" name="id" value="' + v.id + '"><button class="tcd-btn tcd-btn--primary tcd-btn--md" type="submit">Add to cart</button></form>' : '<a class="tcd-btn tcd-btn--alt tcd-btn--md" href="' + p.url + '">View product</a>') + '</div></div></article></li>';
      } catch (e) { /* skip */ }
    }
    if (html) { grid.innerHTML = html; sec.hidden = false; }
  }

  function init() {
    headerOffset(); window.addEventListener('resize', headerOffset);
    const root = $('[data-tcd-product]');
    if (root) { $$('[data-tcd-gallery]', root).forEach(initGallery); initVariants(root); initStickyBar(root); }
    $$('[data-tcd-content]').forEach(initContent);
    initRecs(); initRecent();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
